import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ChatBatchResult } from '../ChatBatchResult'

@InputType()
export class BatchCloseChatsArgs extends ActionArgs {
  @Field(() => [ID])
  chatIds: string[]
}

export interface IBatchCloseChats extends IAction<ChatBatchResult, BatchCloseChatsArgs> {}
